import React from 'react';
import AddItemIcon from '@mui/icons-material/AddCircle';
import { Button } from '@mui/material';

import { hasProjectHierarchyFeatureFlag } from '@paragon/login-tools';

import { useAppMonitor } from '../../../../../monitor';
import { createLevelAndSaveProject } from '../../../../../store/actions/layout/hierarchyActions';
import { isInsertingAnyObject } from '../../../../../store/selectors/insertionObjectSelectors';
import { getVisibleBuildingGuidOrNull } from '../../../../../store/selectors/layoutDataSelectors';
import { useAppDispatch, useAppSelector } from '../../../../hooks';

export function AddLevelButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const clientContext = useAppSelector((state) => state.application.openContext);
  const activeBuildingGuid = useAppSelector(getVisibleBuildingGuidOrNull);
  const isInsertingObject = useAppSelector(isInsertingAnyObject);
  const projectHierarchyModificationEnabled = useAppSelector(hasProjectHierarchyFeatureFlag);

  if (clientContext?.type !== 'project' || !projectHierarchyModificationEnabled) return null;

  return (
    <Button
      variant="outlined"
      startIcon={<AddItemIcon />}
      disabled={isInsertingObject || activeBuildingGuid == null}
      onClick={async () => {
        monitor.recordInteraction('Add Level button clicked');
        await dispatch(createLevelAndSaveProject(activeBuildingGuid!, { selectAfterCreation: true }));
      }}
    >
      Add Level
    </Button>
  );
}
